<style type="text/css" scoped>
.live-agent-card{
	/*height: 229px;*/
	background: #FFFFFF;
	box-shadow: 0px 5px 10px rgba(157, 149, 149, 0.25);
	border-radius: 10px;
	
}
.live-agent-scoll-box{
	height: 180px;
	overflow-y: scroll;
}
.sub-outline-card{
	width: 127.25px;
	height: 100px;
	text-align: center;
	box-sizing: border-box;
	border-radius: 25px;
}

.border-paymnets{
	border: 2px solid #1DC895;
	color: #1DC895;
}
.border-returns{
	border: 2px solid #F2994A;
	color: #F2994A;
}
.border-pending{
	border: 2px solid #2D9CDB;
	color:#2D9CDB;
}
</style>
<template>
	<div>
		<div>
			<v-card class="live-agent-card pa-4"> 
				<p class="sub-title-text">{{$lang.LIVE_AGENTS}}</p>	
				<div class="live-agent-scoll-box">
					<div class="mt-3" v-for="(agent, i) in agent_list" :key="i">
						<div>
							<p class="status-text-filter fs-16 fw-bold">{{agent.agent_name}}
								<small class="secondary-text fs-12">({{agent.agent_type}})</small>
							</p>
							<p class="sub-text-light">{{$lang.MOBILE_PREFIX}}{{agent.agent_phone_number}}</p>	
							<!-- <p class="sub-text-light">{{agent.agent_type}}</p>	 -->
						</div>
					</div>
				</div>
			</v-card>

		</div>

		<div class="mt-6 d-flex text-center">
			<v-card class="sub-outline-card border-paymnets pt-2 "> 
				<p class="fs-36 fw-bold">{{status_counts.payment_count}}</p>
				<p class="fs-14 fw-bold">{{$lang.PAYMENTS}}</p>
			</v-card>
			
			<v-card class="sub-outline-card border-returns pt-2 mx-5 cursor-pointer btn-whithout-hover" @click="$router.push({name:'shipments',query:{shipment_status:encript($keys.RETURN)}})"> 
				<p class="fs-36 fw-bold">{{status_counts.returned_count}}</p>
				<p class="fs-14 fw-bold">{{$lang.RETURNS}}</p>
			</v-card>

			<v-card class="sub-outline-card border-pending pt-1 cursor-pointer btn-whithout-hover" @click="$router.push({name:'shipments',query:{shipment_status:encript($keys.CONFIRMATION_PENDING)}})"> 
				<p class="fs-36 fw-bold">{{status_counts.new_order_count}}</p>
				<p class="fs-14 fw-bold">{{$lang.PENDING_CONFIRMATION}}</p>
				<p class="fs-14 fw-bold"></p>
			</v-card>
		</div>
	</div>
</template>
<script type="text/javascript">
export default{

	props:["agent_list","status_counts"],
}
</script>
